import * as Yup from "yup"
import { isValidPhoneNumber } from "react-phone-number-input"

// Validation for the invite form. Mirrors the app's Yup usage (see
// Preferences/SubscriptionBillingCard validations). The cellphone field is the
// country-code picker (PhoneFieldWithLabel), so it hands us an E.164 string and
// we can run the same libphonenumber check the client form uses
// (PhoneNumberValidator). The backend (phony_plausible) stays authoritative.
export const inviteValidationSchema = Yup.object().shape({
  first_name: Yup.string().trim().required("First name is required"),
  last_name: Yup.string().trim().required("Last name is required"),
  email: Yup.string().trim().email("Enter a valid email address").required("Email is required"),
  cellphone_number: Yup.string()
    .trim()
    .required("Cellphone number is required")
    .test("valid-phone", "Enter a valid cellphone number", (value) =>
      Boolean(value && isValidPhoneNumber(value))
    ),
})
